import styled from 'styled-components';
import mainColors from '../../../../Style-guide/main-colors';

const WallpaperWrapper = styled.section`
  background: ${mainColors.main_color_gradient};
  display: flex;
  justify-content: space-between;
  margin: 12px 0;

  .writings {
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;

    * {
      box-shadow: 0px 0px 40px 4px ${mainColors.dark_background};
    }
  }

  .wallpaper-image-container {
    width: 100%;
    margin: 0;

    .wallpaper-image {
      max-height: 400px;
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }
`;

export default WallpaperWrapper;
